<template>
  <div>
    <div class="main-cates">
      <div
        class="item-block"
        v-for="(item, index) in selfServiceList"
        :key="index"
        @click="handleJump(item)"
      >
        <img class="imgCon" :src="item.imgUrl" />
        <div class="text">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
const selfServiceList = [
  {
    name: '物流查询',
    type: 'logisticsSearch',
    jumpUrl: 'zljgo://native_api?type=20&needlogin=1',
    imgUrl: require('../../assets/img/logistics_search.png')
  },
  {
    name: '售后查询',
    type: 'afterSaleSearch',
    jumpUrl: 'zljgo://native_api?type=1&needlogin=1&content=https://feentry.zhuanzhuan.com/AfterSale?clientid=List',
    imgUrl: require('../../assets/img/aftersal_search.png')
  },
  // {
  //   name: '投诉中心',
  //   type: 'compliantCenter',
  //   jumpUrl: 'zljgo://native_api?type=1&needlogin=1&content=https%3A%2F%2Ffrontstatic.zhaoliangji.com%2Fpages%2Fshop-complaint%2Findex.html%3Fhideshare%3D1%26showclose%3D1',
  //   imgUrl: require('../../assets/img/complaint_center_zlj.png')
  // },
  {
    name: '投诉中心',
    type: 'compliantCenter',
    jumpUrl: 'https://feentry.zhuanzhuan.com/zlj?clientid=cs_sc_ts',
    imgUrl: require('../../assets/img/complaint_center_zlj.png')
  },
  {
    name: '到货通知',
    type: 'arrivalNotice',
    jumpUrl: 'zljgo://native_api?type=21',
    imgUrl: require('../../assets/img/arrival_notice.png')
  },
  {
    name: '二手换钱',
    type: 'exchangeMonney',
    jumpUrl: 'zljgo://native_api?type=1&content=https://m.zhuanzhuan.com/u/bm-core/index?showtitlebar=0&needNewWebView=1&needHideHead=1&channel=ZLJ_0100B',
    imgUrl: require('../../assets/img/exchange_moneny.png')
  },
  {
    name: '服务中心',
    type: 'serviceCenter',
    jumpUrl: 'zljgo://native_api?type=1&content=https%3A%2F%2Ffrontstatic.zhaoliangji.com%2Fshop%2Fclause%2Fafter-sale.html',
    imgUrl: require('../../assets/img/service_center.png')
  },
  {
    name: '常见问题',
    type: 'commonQuestion',
    jumpUrl: 'zljgo://native_api?type=1&content=https%3A%2F%2Ffrontstatic.zhaoliangji.com%2Fpages%2Fshop-h5%2Fkf-common-problem.html',
    imgUrl: require('../../assets/img/common_question.png')
  },
  {
    name: 'APP问题反馈',
    type: 'appQuestionFeedback',
    jumpUrl: 'zljgo://native_api?type=31&needlogin=1&content=%7B%22type%22%3A1%7D',
    imgUrl: require('../../assets/img/app_question_feedback.png')
  }
]
export default {
  name: 'ZLJServiceList',
  data() {
    return {
      selfServiceList
    }
  },
  methods: {
    handleJump: function(item) {
      const jumpUrl = item.jumpUrl
      // if (item.type === 'moreService') {
      //   this.$router.push({
      //     name: 'zljServiceListPage'
      //   })
      //   return
      // }
      native.skipToUrl({ targetUrl: jumpUrl })
    }
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
